export enum UnitOfMeasurement {
Piece,
Meter,
SquareMeter,
}
